// Generated by purs version 0.15.0
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var coerce = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
export {
    coerce
};
//# sourceMappingURL=index.js.map
